
import eventHub from "@/eventHub";
import { CustomerInfoModel } from "@/models/customerModels";
import { AddedSkuToCartResponse, AddSkuToCart, AddSkuToCartRequest } from "@/models/productModel";
import { defineComponent, computed, watch, onMounted, ComputedRef, ref, getCurrentInstance } from "vue";
import axios from "axios";

export default defineComponent({
	setup(props, context) {
		const instance = getCurrentInstance();
  
		const lang = computed(() => instance.proxy.$store.state.appCulture);
		const currentCustomer: ComputedRef<CustomerInfoModel> = computed(() => instance.proxy.$store.state.currentCustomer);
		
		const addProductsToCart = (products: any[]) => {
			const productIds = products.map(p => p.productId)
			isAddingToCart.value = true;
			if (productIds != null && productIds.length > 0) {
				var request = new AddSkuToCartRequest();
				productIds.forEach(x => {
					if (request.products.find(r => r.productId == x) == null) {
						var p = new AddSkuToCart();
						p.customerId = currentCustomer.value ? currentCustomer.value.id : null;
						p.productId = x;
						p.quantity = 1;
						request.products.push(p);
					}
				});
				axios
					.post<AddedSkuToCartResponse>(`cart/addproducts`, request)
					.then(res => {
						instance.proxy.$store.commit("setCurrentCart", res.data.cart);
						res.data.products.forEach(x => instance.proxy.$set(x, "source", "myareaPage"));
						eventHub.$emit(eventHub.events.CART_UPDATED, res.data.products);
					})
					.catch(error => {
						console.error(error);
					})
					.finally(() => (isAddingToCart.value = false));
			} else isAddingToCart.value = false;
		};

		const goToProductPage = (productId: number) => instance.proxy.$router.push({ path: `/product/${productId}` });
		
		const goToOrderPage = orderId => instance.proxy.$router.push({ path: `/order/${orderId}` }); // console.log("go to order " + orderId)

		const getAuthToken = () => localStorage.getItem("ConvPortal-Token");

		let widgetInstance;

		const isAddingToCart = ref(false);
		const widgetOptions = {
			apiBasePath: `${process.env.VUE_APP_BASE_URL}`,
			tokenCallback: getAuthToken,
			orderDetailCallback: goToOrderPage,
			productDetailCallback: goToProductPage,
			addProductsToCartCallback: addProductsToCart,
			enableBillingAddresses: false,
            enableAddressesEditing: false,
            enableAddresseDefaultHandling: false,
          	showAddressesAsCards: false,
			currentCustomerId: currentCustomer.value ? currentCustomer.value.id : null,
			orders: {
				showPayment: false,
				showCustomerReference: true
			}
		};

		const loadWidget = async () => {
			try {
				widgetInstance = await (window as any).initEcommerceMyArea("#kd-widget", lang.value, widgetOptions);
			} catch (error) {
				console.log("Errore inizializzazione widget myArea: " + error);
			}
		};

		onMounted(async () => {
			await loadWidget();
		});

		
		const showCustomerModal = ref(false);

		const onSelectCustomer = (customer: CustomerInfoModel) => {
			instance.proxy.$store.commit("setCurrentCustomer", customer);
			showCustomerModal.value = false;
		};

		watch(currentCustomer, (newCustomer, oldCustomer) => {
			if (widgetInstance) {
				widgetInstance.setCurrentCustomerId(newCustomer ? newCustomer.id : null);
			}
		});

		return { currentCustomer, showCustomerModal, onSelectCustomer, isAddingToCart };
	}
});
